import type { TranslationDict } from './ru';

/**
 * v5.5 — English translations.  Mirror of ru.ts. Если ключа нет — useT
 * fall-backs на ru.ts (так что неполный перевод работает).
 *
 * Структура должна совпадать с ru.ts; если добавляешь key туда —
 * не забудь и здесь.
 */
export const en: TranslationDict = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    loading: 'Loading...',
    submit: 'Submit',
    back: 'Back',
    error: 'Error',
    success: 'Done',
  },
  auth: {
    login: 'Log in',
    register: 'Sign up',
    logout: 'Log out',
    email: 'Email',
    username: 'Username',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    restoreAccount: 'Restore a deleted account',
    loginCta: 'Sign in to SWIPA',
    noAccount: 'No account?',
    createAccount: 'Create',
  },
  settings: {
    title: 'Settings',
    sections: {
      profile: 'Profile',
      sessions: 'Active sessions',
      privacy: 'Privacy',
      notifications: 'Notifications',
      account: 'Account & data',
      language: 'Language',
    },
    privacy: {
      hideLastSeen: 'Hide "last seen"',
      hideOnline: 'Hide online status',
      hideReadReceipts: 'Hide read receipts',
      whoCanCallMe: 'Who can call me',
      whoCanAddMeToChannels: 'Who can add me to channels',
    },
    account: {
      export: 'Download my data',
      delete: 'Delete account',
      deleteConfirm: 'Delete account?',
      deleteHint: 'Restorable within 30 days via email.',
    },
    language: {
      ru: 'Русский',
      en: 'English',
    },
  },
  channel: {
    joined: '{{name}} joined #{{channel}}',
    left: '{{name}} left #{{channel}}',
    kicked: '{{name}} was kicked from #{{channel}}',
    banned: '{{name}} was banned from #{{channel}}',
    motd: 'MOTD',
    slowMode: 'Slow mode: wait {{seconds}}s',
    transferOwnership: 'Transfer channel ownership',
  },
  errors: {
    network: 'No server connection',
    unauthorized: 'Not authorized',
    forbidden: 'Action not allowed',
    notFound: 'Not found',
    rateLimited: 'Too many requests',
    automodBlocked: 'Message rejected by moderation',
  },
};
